import './App.css';
import Sidebar from './components/Sidebar';
import Content from './components/Content';

function App() {
  return (
    <div className="container-fluid">
      <div className="section">
        <div className="row">
          <Sidebar />
          <Content />
        </div>
      </div>
    </div>
  );
}

export default App;
